var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChatBubbles = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.145 15.503 1.29-2.255a.5.5 0 0 0-.123-.638C1.852 11.44 1 9.717 1 7.935 1 4.406 4.562 1.5 9 1.5c4.438 0 8 2.906 8 6.435a.5.5 0 0 0 1 0C18 3.804 13.95.5 9 .5S0 3.804 0 7.935c0 1.951.867 3.833 2.36 5.177l-1.794 3.14a.5.5 0 0 0 .62.712l4.839-1.935a9.66 9.66 0 0 0 1.348.28.5.5 0 1 0 .134-.992 8.62 8.62 0 0 1-1.361-.295.5.5 0 0 0-.332.014l-3.669 1.467Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.824 23.968a.5.5 0 0 0 .623-.692l-1.324-2.649C23.348 19.521 24 18.107 24 16.5c0-3.502-3.435-6.5-7.5-6.5-4.065 0-7.5 2.998-7.5 6.5 0 4.7 5.334 7.967 10.012 6.039l3.812 1.43Zm-3.648-2.436a.5.5 0 0 0-.38.011C14.72 23.356 10 20.52 10 16.5c0-2.917 2.96-5.5 6.5-5.5s6.5 2.583 6.5 5.5c0 1.427-.619 2.655-1.812 3.61a.5.5 0 0 0-.135.614l.93 1.86-2.807-1.052Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChatBubbles);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chat-bubbles.5753ff239da6b9c85c87c3b610399434.svg";